// A builder session is the recipe being edited, not the latest object snapshot.
// Refreshes may replace a recipe object while the user is editing it.
export const recipeBuilderSessionKey = recipe => String(recipe?.id || recipe?._id || "new-recipe");

export const shouldResetRecipeBuilderState = (previousSessionKey, nextRecipe) =>
  previousSessionKey !== recipeBuilderSessionKey(nextRecipe);
